export default __webpack_public_path__ + "static/media/logo_dark.dedbc991.png";